import { CommonModule, DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ReportServiceService } from '../../../services/Report-service/report-service.service';
import { NgxPaginationModule } from 'ngx-pagination';
import { LoadingSpinnerComponent } from '../../../components/loading-spinner/loading-spinner.component';
import { ManageOfficersService } from '../../../services/manage-officers-service/manage-officers.service';
import { ToastAlertService } from '../../../services/toast-alert/toast-alert.service';
import Swal from 'sweetalert2';
import { environment } from '../../../environments/environment';
import { CustomDatepickerComponent } from "../../../components/custom-datepicker/custom-datepicker.component";

@Component({
  selector: 'app-center-collection-expense',
  standalone: true,
  imports: [CommonModule, FormsModule, NgxPaginationModule, LoadingSpinnerComponent, CustomDatepickerComponent],
  templateUrl: './center-collection-expense.component.html',
  styleUrl: './center-collection-expense.component.css',
  providers: [DatePipe]
})
export class CenterCollectionExpenseComponent implements OnInit {

  @ViewChild('fromDatePicker') fromDatePicker!: CustomDatepickerComponent;
  @ViewChild('toDatePicker') toDatePicker!: CustomDatepickerComponent;

  farmerPaymentsArr!: FarmerPayments[];
  centerArr: Center[] = [];
  totalPaymentsAmount: number = 0; // New variable to store the sum of all payments

  centerId!: number;

  page: number = 1;
  totalItems: number = 0;
  itemsPerPage: number = 10;
  hasData: boolean = true;

  searchText: string = '';

  fromDate: Date | string = '';
  toDate: Date | string = '';

  isPopupVisible: boolean = false;
  logingRole: string | null = null;
  isLoading: boolean = false;
  isDateFilterSet: boolean = false;

  selectedFromDate: string | Date | null = null;
  selectedToDate: string | Date | null = null;

  maxDate: string = new Date().toISOString().split('T')[0];


  isDownloading = false;

  constructor(
    private router: Router,
    private ReportSrv: ReportServiceService,
    private datePipe: DatePipe,
    private ManageOficerSrv: ManageOfficersService,
    private toastSrv: ToastAlertService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.centerId = this.route.snapshot.params['id'];

  }

  navigate(path: string) {
    this.router.navigate([`${path}`]);
  }

  fetchFilteredPayments(page: number = 1, limit: number = this.itemsPerPage) {
    this.isLoading = true;

    this.ReportSrv.getAllCenterPayments(
      page,
      limit,
      this.fromDate,
      this.toDate,
      this.centerId,
      this.searchText
    ).subscribe(
      (res) => {
        this.farmerPaymentsArr = res.items;
        this.totalItems = res.total;
        this.totalPaymentsAmount = res.grandTotal
        this.hasData = res.items.length > 0;
        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }

  private formatNumberToTwoDecimals(value: any): number {
    const num = typeof value === 'string' ? parseFloat(value) : Number(value);
    return parseFloat(num.toFixed(2));
  }

  onSearch() {
    this.page = 1;
    this.fetchFilteredPayments();
  }

  offSearch() {
    this.searchText = '';
    this.fetchFilteredPayments();
  }

  onPageChange(event: number) {
    this.page = event;

    this.fetchFilteredPayments(this.page, this.itemsPerPage);
  }

  onFromDateChange(newDate: string | Date | null) {
    this.selectedFromDate = newDate;

    if (this.selectedFromDate && this.selectedFromDate > this.maxDate) {
      this.selectedFromDate = null; // Set to null instead of empty string
      this.fromDate = '';

      if (this.fromDatePicker) {
        this.fromDatePicker.selectedDate = null;
      }
      this.toastSrv.warning("From date cannot be in the future.");
      return;
    }

    this.fromDate = this.selectedFromDate
      ? this.selectedFromDate.toString().split('T')[0]
      : '';
    this.validateFromDate();
  }

  onToDateChange(newDate: string | Date | null) {
    this.selectedToDate = newDate;

    if (this.selectedToDate && this.selectedToDate > this.maxDate) {

      this.selectedToDate = null;
      this.toDate = '';
      if (this.toDatePicker) {
        this.toDatePicker.selectedDate = null;
      }

      this.toastSrv.warning("To date cannot be in the future.");
      return;
    }

    this.toDate = this.selectedToDate
      ? this.selectedToDate.toString().split('T')[0]
      : '';
    this.validateToDate();
  }


  validateToDate() {
    // Case 1: User hasn't selected fromDate yet
    if (!this.fromDate) {
      this.toDate = ''; // Reset toDate
      this.selectedToDate = null;

      if (this.toDatePicker) {
        this.toDatePicker.selectedDate = null;
      }
      this.toastSrv.warning("Please select the 'From' date first.");
      return;
    }

    // Case 2: toDate is earlier than fromDate
    if (this.toDate) {
      const from = new Date(this.fromDate);
      const to = new Date(this.toDate);

      if (to <= from) {
        this.toDate = ''; // Reset toDate
        this.selectedToDate = null;

        if (this.toDatePicker) {
          this.toDatePicker.selectedDate = null;
        }
        this.toastSrv.warning("The 'To' date cannot be earlier than or same to the 'From' date.");
      }
    }
  }

  validateFromDate() {
    // Case 1: User hasn't selected fromDate yet
    if (!this.toDate) {
      return;
    }

    // Case 2: toDate is earlier than fromDate
    if (this.toDate) {
      const from = new Date(this.fromDate);
      const to = new Date(this.toDate);

      if (to <= from) {
        this.fromDate = ''; // Reset toDate
        this.selectedFromDate = null;

        if (this.fromDatePicker) {
          this.fromDatePicker.selectedDate = null;
        }
        this.toastSrv.warning("The 'From' date cannot be Later than or same to the 'From' date.");
      }
    }
  }


  goBtn() {
    if (!this.fromDate || !this.toDate) {
      this.toastSrv.warning("Please fill in all fields");

      this.hasData = false;
      return;
    }
    this.isDateFilterSet = true;
    this.fetchFilteredPayments();
  }

  downloadTemplate1() {
    this.isDownloading = true;

    this.ReportSrv
      .downloadCenterPaymentReportFile(this.fromDate, this.toDate, this.centerId, this.searchText)
      .subscribe({
        next: (blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `Expenses Report From ${this.fromDate} To ${this.toDate}.xlsx`;
          a.click();
          window.URL.revokeObjectURL(url);

          Swal.fire({
            icon: "success",
            title: "Downloaded",
            text: "Please check your downloads folder",
            customClass: {
              popup: 'bg-white dark:bg-[#363636] text-gray-800 dark:text-white',
              title: 'dark:text-white',
            }
          });
          this.isDownloading = false;
        },
        error: (error) => {
          Swal.fire({
            icon: "error",
            title: "Download Failed",
            text: error.message,
            customClass: {
              popup: 'bg-white dark:bg-[#363636] text-gray-800 dark:text-white',
              title: 'dark:text-white',
            }
          });
          this.isDownloading = false;
        }
      });
  }

  navigateToFarmerReport(invNo: string) {
    this.router.navigate([`reports/farmer-report-invoice/${invNo}`]);
  }

  navigateToCenterTarget() {
    this.router.navigate(['/centers']); // Change '/reports' to your desired route
  }

}

class FarmerPayments {
  invNo!: string;
  totalAmount!: number;
  centerCode!: string;
  centerName!: string;
  nic!: string;
  firstNameEnglish!: string;
  gradeAprice!: number;
  gradeBprice!: number;
  gradeCprice!: number;
  gradeAquan!: number;
  gradeBquan!: number;
  gradeCquan!: number;
  status!: string;
  createdAt!: string | Date;
  companyId!: number;
}

class Center {
  id!: number;
  centerName!: string;
  regCode!: string;
}
